module.exports = __webpack_public_path__ + "assets/img/modal-avatar-150e244b.png";